import React, { useState, useEffect } from "react";
import { useNavigate, useLocation, Link, useParams } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import AuthService from "../../services/auth.service";
import { setUser } from "../../stores/user";

const required = (value) => {
  if (!value) {
    return (
      <div
        className="alert alert-danger"
        role="alert"
      >
        This field is required!
      </div>
    );
  }
};
function ResetPassword() {
  const user = useSelector((store) => store.user);
  const [email, setEmail] = useState("");
  const [token, setToken] = useState("");
  const [password_confirmation, setPassword_confirmation] = useState("");
  const [password, setPassword] = useState("");
  const [submitted, setSubmitted] = useState(false);
  const [servermessage, setServermessage] = useState("");
  const [success, setSuccess] = useState(false);

  const navigate = useNavigate();
  const location = useLocation();
  const dispatch = useDispatch();

  // console.log("Params:" + JSON.stringify(token));

  const handleReset = (e) => {
    e.preventDefault();
    AuthService.savepassword(
      token,
      email,
      password,
      password_confirmation
    ).then((response) => {
      if (response.data) {
        // dispatch(setUser(response.data));
        // navigate(location.pathname);
        // console.log("Params:" + JSON.stringify(response.data.data));
        setServermessage(response.data.data);
        setSuccess(true);
      } else {
        // console.log(response.data.error)
        setServermessage(response.data.error || response.data.data);
      }
    });
  };

  useEffect(() => {
    var loc = location.search.split("=");
    const token = loc[1].split(";")[0].split("?")[0];
    setToken(token);
    const iemail = loc[2];
    setEmail(iemail);
  }, []);

  return (
    //  New Tailwind reset form
    <div className="flex justify-center items-center min-h-screen">
      <div className="bg-white shadow-md rounded px-8 pt-6 pb-8 mb-4 w-full max-w-md">
        <span className="text-red-600">{servermessage}</span>
        <h2 className="text-3xl font-bold mb-6 text-center text-white">
          <span className="bg-gradient-to-r text-transparent from-blue-500 to-purple-500 bg-clip-text">
            Reset Password
          </span>
        </h2>
        <form onSubmit={handleReset}>
          <div className="mb-6">
            <label
              id="email"
              className="block text-gray-700 text-sm font-bold mb-2"
            >
              <i className="fas fa-envelope mr-2"></i>Email
            </label>
            <div>
              <input
                id="email"
                type="email"
                className="shadow appearance-none border rounded w-full py-3 px-4 text-gray-700 leading-tight focus:outline-none focus:shadow-outline"
                placeholder={email}
                name="email"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                validations={[required]}
              />
            </div>
          </div>
          <div className="mb-6">
            <label
              id="password"
              className="block text-gray-700 text-sm font-bold mb-2"
            >
              <i className="fas fa-lock mr-2"></i>Password
            </label>
            <div>
              <input
                id="password"
                type="password"
                className="shadow appearance-none border rounded w-full py-3 px-4 text-gray-700 leading-tight focus:outline-none focus:shadow-outline"
                placeholder="Enter your password"
                name="password"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                validations={[required]}
              />
            </div>
          </div>
          <div className="mb-6">
            <label
              id="corfirm-password"
              className="block text-gray-700 text-sm font-bold mb-2"
            >
              <i className="fas fa-lock mr-2"></i>Confirm Password
            </label>
            <div>
              <input
                id="password_confirmation"
                type="password"
                className="shadow appearance-none border rounded w-full py-3 px-4 text-gray-700 leading-tight focus:outline-none focus:shadow-outline"
                placeholder="Confirm password"
                name="password_confirmation"
                value={password_confirmation}
                onChange={(e) => setPassword_confirmation(e.target.value)}
                validations={[required]}
              />
            </div>
          </div>
          <div className="flex items-center justify-center">
            <button
              type="submit"
              className="bg-gradient-to-r from-blue-500 to-purple-500 hover:from-blue-700 hover:to-purple-700 text-white font-bold py-3 px-4 rounded focus:outline-none focus:shadow-outline w-full"
            >
              Save Password
            </button>
          </div>
          <div className="flex row gap-36 text-center mt-4"></div>
        </form>
      </div>
    </div>
  );
}

export default ResetPassword;
